import Home from './Pages/Home.svelte';
import Learn from './Pages/Learn.svelte';
import Test from './Pages/Test.svelte';

export const routes = {
  '/': Home,
  '/learn': Learn,
  '/test': Test
};
